module.exports = __webpack_public_path__ + "assets/img/travel-day4.76b50405.png";